import React from "react";
import ContentLoader from "react-content-loader";

import "./HomepageSliderLoader.scss";

export const HomepageSlideLoader = () => {
  return (
    <div className="HomepageSlideLoader">
      <ContentLoader
        speed={2}
        width="100%"
        height="calc(100vh - 123px)"
        backgroundColor="#f3f3f3"
        foregroundColor="#e7e3e3"
        className="HomepageSlideLoader__full"
      >
        <rect x="0" y="0" width="100%" height="calc(100vh - 123px)" />
      </ContentLoader>
    </div>
  );
};
